<template>
  <Modal :id="'cmp-contacts-import_export-merge_contact'" @cancelled="onCancel">
    <template slot="header">MERGE CONTACT</template>

    <template slot="body">
      <div class="ut-flex" style="gap:10px">
        <div  style="flex:1" class="ut-fc">
          <CompareModalContact
            :contact="contact1"
            :languagesTV="languagesTV"
            :countriesTV="countriesTV"
            :currencyTV="currencyTV"
            :paymentMethodsTV="paymentMethodsTV"
            :contactKey="'contact1'"
            :selectedContactID="selectedContactID"
            @change="onChange"
            @selectClick="onSelectClick"
          />
        </div>
        <div  style="flex:1" class="ut-fc">
          <CompareModalContact
            :contact="contact2"
            :languagesTV="languagesTV"
            :countriesTV="countriesTV"
            :currencyTV="currencyTV"
            :paymentMethodsTV="paymentMethodsTV"
            :contactKey="'contact2'"
            :selectedContactID="selectedContactID"
            @change="onChange"
            @selectClick="onSelectClick"
          />
        </div>

      </div>
    </template>
    <template slot="options">
     
      <button class="dt-button s6" @click.stop="onCancel">{{$t('cancel')}}</button>
      <button
        class="dt-button v1 s6"
        @click="onClickOK"
        :disabled="selectedContactID==0"
        :class="{ disabled: selectedContactID==0 }"
      >
        {{ $t("ok") }}
      </button>
    </template>
  </Modal>

</template>

<script>

import { ContactIMEXService } from "../../services/contact_import_export.service";

import Modal from "@/dt-plugins/modal/modal";

import { EventHooks } from "../../../../plugins/text-field";
import { createTV } from '../../../../models/text-value.model';
import CompareModalContact from './compare-modal-contact.vue';
import { NotificationService } from '../../../../dt-plugins/notification/notification.service';

export default {
  components: {
    CompareModalContact,
    Modal,

  },
  mounted:async function () {
    console.log(this.$route.query)
    
    const resData = await ContactIMEXService.getMergeModalData(this.contact_ids);
    console.log("resData::::",resData)
    this.contact1 = resData.data.contact1[0];
    this.contact2 = resData.data.contact2[0];
    this.languageArray = resData.data.languages;
    this.countryArray = resData.data.countries;
    this.currencyArray = resData.data.currencies;
    this.paymentMethodArray = resData.data.payment_methods;
  },
  data: function () {
    return {
      textFieldConfig: {
        height: 42,
        showEditIconOnHover: false,
        box: true,
        showValidationIcons: false,
        valueChangedEvent: EventHooks.OnBlur
      },
      contact1: {},
      contact2: {},
      languageArray:[],
      countryArray:[],
      currencyArray:[],
      paymentMethodArray:[],
      selectedContactID:0
    };
  },

  watch: {},
  computed: {
    contact_ids: function () {
      return this.$route.query.contact_ids;
    },
    languagesTV:function(){
      return createTV(this.languageArray ,'key','index')
    },
    countriesTV:function(){
      return this.countryArray.map(x=>{
        return {
          text:x,
          value:x
        }
      })
    },
    currencyTV:function(){
      return createTV(this.currencyArray,'currency_iso','currency_id')
    },
    paymentMethodsTV:function(){
      return createTV(this.paymentMethodArray,'value','index')
    }
  },
  methods: {
    onCancel() {
      this.$emit("cancelled");
    },
    onSelectClick:function(contact_id){
        console.log("::::::",contact_id)
        this.selectedContactID = contact_id
    },
    onChange: function ({name,value,key}) {    
      
   
      console.log(name,value,key)
      this[key][name] = value

    },
    onClickOK:async function() {
      let removeableContactID = parseInt(this.contact1.contact_id) == parseInt(this.selectedContactID)? this.contact2.contact_id: this.contact1.contact_id;
      const res = await ContactIMEXService.finishContactMerge(this.selectedContactID,removeableContactID);

      console.log(res.data)

      if(res.data.msg==1){
        NotificationService.showNotification({
          text: "Merge Successful",
          timeout: 2000,
          type: "Normal",
        });
      }
        
      this.onCancel();
    },

  },
};
</script>

<style lang="scss">
.cmp-contacts-import_export-merge_contact {
  .green-input-box .dt-input-box--container .dt-input-box.box,
  .green-input-box .dropdown.box {
    border: 2px solid green !important;
  }
}

// .search {
//   padding: 10px 0 10px 10px !important;
// }
// .cb-filters {
//   padding: 5px 10px !important;
// }
// .cb-flex {
//   padding-top: 5px;
// }

// .checkbox-container {
//   padding: 5px 0;
// }

// .form-group .dt-dropdown {
//   margin: 5px 5px !important;
// }

// .contacts {
//   .contact-item {
//     padding: 5px;

//     .checkbox-container {
//       padding: 5px 0px;
//     }

//     &:nth-child(even) {
//       background: var(--sprt-8);
//     }
//     .contact-name {
//       cursor: pointer;
//     }
//   }
// }
</style>
